import React from 'react';
import './index.less';
import noAuth from '@sg/assests/images/noAuth.png';

interface NoAuthPageProps {
  pageId?: string;
  admins: string[];
  height?: string;
}

const NO_AUTH_IMAGE_SIZE = 200;

const NoAuthPage: React.FC<NoAuthPageProps> = ({ pageId, admins, height }) => (
  <div className="no-auth-container" style={{ height }}>
    <div className="no-auth-content">
      <div className="no-auth-image-wrap">
        <img
          src={noAuth}
          alt="No Access"
          className="no-auth-image"
          width={NO_AUTH_IMAGE_SIZE}
          height={NO_AUTH_IMAGE_SIZE}
          decoding="sync"
          fetchPriority="high"
        />
      </div>
      <div className="no-auth-text">
        <h1 className="no-auth-title">Access Restricted</h1>
        <p className="no-auth-description">
          Access to this page is limited to authorized users only.
        </p>
        <p className="no-auth-admins">
          To request access, please reach out to administrators {admins.join(' or ')}.
        </p>
      </div>
    </div>
  </div>
);

export default NoAuthPage;